<div (click)="click()" class="btn-cancel {{ disabled ? 'btn-cancel--disabled' : '' }}">
    <ng-content></ng-content>
</div>
